import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';
import { mockSalesForecast, totalForecastedDemand } from '../../data/mockData';

export function SalesForecastCard() {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">
          3-Month Sales Forecast
        </CardTitle>
        <TrendingUp className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">
          {totalForecastedDemand.toLocaleString()} units
        </div>
        <p className="text-xs text-muted-foreground mb-3">
          Microprocessor chips forecasted for Q1 2026
        </p>
        <div className="space-y-2">
          {mockSalesForecast.map((forecast) => (
            <div
              key={forecast.period}
              className="flex items-center justify-between text-sm"
            >
              <span className="text-muted-foreground">{forecast.period}</span>
              <div className="flex items-center gap-2">
                <span className="font-medium">
                  {forecast.forecastedUnits.toLocaleString()}
                </span>
                <span className="text-xs text-muted-foreground">
                  ({forecast.confidence}% conf.)
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
